import moment from 'moment';

class SalesCommunication {
    constructor(json) {
        if (json) {
            this.storageId = json.storageId;
            this.id = json.id;
            this.customerId = json.customerId;
            this.communicationType = json.communicationType;
            this.direction = json.direction;
            this.occurredAt = moment(json.occurredAt);
            this.description = json.description;
        } else {
            this.storageId = null;
            this.id = null;
            this.customerId = null;
            this.communicationType = 1;
            this.direction = 1;
            this.occurredAt = null;
            this.description = '';
        }
    }
}

export default SalesCommunication;
